// extracted by mini-css-extract-plugin
export default {"accordion":"Accordian_accordion__Vb3bb","panel":"Accordian_panel__-iZvd"};